module.exports = __webpack_public_path__ + "img/03-reduced-range-anxiety.c9507b29.png";